import { api } from "@/api";

import { QueryProps } from "@/types/Api";
import { FeedType, SportEvent } from "@/types/SportsApiResponses";
import { SportType } from "./getSportEventsNew";

interface Params {
  feedType?: FeedType;
  sportType: SportType;
  lang: string;
}

export const getTopSportEventsNew = async (
  props: QueryProps<Params>
): Promise<SportEvent[]> => {
  const res = await api.client.get(`/sport-events-new/top`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
